import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Minnesota = () => {
  return (
    <StatePropertyTaxPage
      stateName="Minnesota"
      processDescription="Appeals must be filed with the local board of appeal and equalization or county board. The deadline is April 30 or as stated on the valuation notice. Appeals can be made online, by mail, or in-person."
      noticeOfValueMailed="March"
      noticeOfValueMailedDateExplanation="Notices of Valuation and Classification are mailed by March 31 per Minnesota Department of Revenue guidelines."
      valuationAsOfDate="January 2"
      valuationAsOfDateExplanation="Per Minnesota Statutes § 273.01, all real property is valued as of January 2 each assessment year. This unique assessment date (January 2 instead of January 1) is specific to Minnesota's property tax system."
      deadlineExplanation="By statute, appeals must be filed by April 30 or the date published on the notice. This deadline is consistent statewide and allows property owners approximately 30 days to file their appeals."
      stateStatute="https://www.revisor.mn.gov/statutes/cite/273.01"
    />
  );
};

export default Minnesota;